import type { ApexActivity } from './activities';

// The short description that is shown on the transactions list screen.  The full
// transaction description is shown on the detail sheet.
export const buildDescription = (
    transaction: ApexActivity,
    _apexAccount: { accountNumber: string; nickname: string },
) => {
    let description: string;
    switch (transaction.subtypeCategory) {
        case 'ACCOUNT_TRANSFER':
            if (
                transaction.accountTransfer.accountTransferType ===
                'FULL_ACCOUNT_TRANSFER'
            ) {
                description = 'Full account transfer';
                break;
            }
            if (
                transaction.accountTransfer.accountTransferType ===
                'PARTIAL_TRANSFER_RECEIVER'
            ) {
                description = 'Partial account transfer';
                break;
            }
            description = 'Account transfer';
            break;
        case 'ALLOCATION':
            if (transaction.side === 'BUY') {
                if (transaction.assetSymbol != null) {
                    description = `${transaction.assetSymbol} buy`;
                    break;
                }
                description = 'Buy';
                break;
            }
            if (transaction.side === 'SELL') {
                if (transaction.assetSymbol != null) {
                    description = `${transaction.assetSymbol} sell`;
                    break;
                }
                description = 'Sell';
                break;
            }
            description = 'Trade';
            break;
        case 'SWEEP':
            if (transaction.sweep.action === 'REDEMPTION') {
                description = 'FDIC sweep out';
                break;
            }
            if (transaction.sweep.action === 'PURCHASE') {
                description = 'FDIC sweep in';
                break;
            }
            description = 'Sweep';
            break;
        case 'DEPOSIT':
            description = 'Deposit';
            break;
        case 'WITHDRAWAL':
            description = 'Withdrawal';
            break;
        case 'CASH_DIVIDEND':
            if (transaction.assetSymbol != null) {
                description = `${transaction.assetSymbol} dividend`;
                break;
            }
            description = 'Dividend';
            break;
        case 'CREDIT':
            if (
                transaction.credit.creditType === 'FDIC_INSURED_DEPOSIT_PROGRAM'
            ) {
                description = 'FDIC sweep interest payment';
                break;
            }
            description = 'Credit';
            break;
        default:
            description = 'Other';
    }

    if (transaction.state === 'CANCEL') {
        return `${description} cancellation`;
    }
    return description;
};

export const readableTransactionType = (transaction: ApexActivity) => {
    const { subtypeCategory } = transaction;

    switch (subtypeCategory) {
        case 'ACCOUNT_TRANSFER':
            if (
                transaction.accountTransfer.accountTransferType ===
                'FULL_ACCOUNT_TRANSFER'
            ) {
                return 'Full account transfer';
            }
            if (
                transaction.accountTransfer.accountTransferType ===
                'PARTIAL_TRANSFER_RECEIVER'
            ) {
                return 'Partial account transfer';
            }
            return 'Account transfer';
        case 'ALLOCATION':
            if (transaction.side === 'BUY') {
                return 'Buy';
            }
            if (transaction.side === 'SELL') {
                return 'Sell';
            }
            return 'Trade';
        case 'SWEEP':
            if (transaction.sweep.action === 'REDEMPTION') {
                return 'Sweep out';
            }
            if (transaction.sweep.action === 'PURCHASE') {
                return 'Sweep in';
            }
            return 'Sweep';
        case 'DEPOSIT':
            return 'Deposit';
        case 'WITHDRAWAL':
            return 'Withdrawal';
        case 'WITHDRAWAL_PENDING_REVIEW':
            return 'Pending withdrawal';
        case 'CASH_DIVIDEND':
            return 'Dividend';
        case 'CREDIT':
            return 'Credit';
        default:
            return transaction.activityDescription;
    }
};
